export const X_CSRF_TOKEN = "x-csrf-token";
export const X_TENANT_VERSION = "x-tenant-version";
export const X_TENANT_SLUG = "x-tenant-slug";
export const X_VAULT_TOKEN = "x-vault-token";
